import React from "react";
import { AddressWithNameInnerForm } from "../../../components/ValidatedFields/AddressWithNameInnerForm";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { NameAndAddress, PostalAndVisitingAddress } from "shared/utils/fieldsHelper/companyFields";

interface Props {
  value: PostalAndVisitingAddress;
  onChange: (addresses: PostalAndVisitingAddress) => void;
  submit: () => void;
  isSaving: boolean;

  noLeftPadding?: boolean;
}

export const PostalAddressForm = (props: Props) => {
  const [isSameAsVisitingAddress, setIsSameAsVisitingAddress] = React.useState(() => {
    return Object.keys(props.value.postalAddress).map(key => {
      return props.value.postalAddress[key] === props.value.visitingAddress[key];
    }).every(value => value);
  });

  const onCheck = (checked: boolean) => {
    setIsSameAsVisitingAddress(checked);
    if (checked) {
      props.onChange({
        visitingAddress: props.value.visitingAddress,
        postalAddress: props.value.visitingAddress
      });
    }
  }

  const onChange = (newPostalAddress: NameAndAddress) => {
    props.onChange({
      visitingAddress: props.value.visitingAddress,
      postalAddress: newPostalAddress
    });
  }

  if (isSameAsVisitingAddress) {
    return <div style={props.noLeftPadding ? { paddingLeft: 0 } : undefined} className="flex-column gap main-section-template-fields-padding">
      <Checkbox
        label={RESX.Company.SameAsVisitingAddress}
        checked={isSameAsVisitingAddress}
        onChange={(_, checked) => onCheck(checked)}
      />
    </div>
  }

  return <div style={props.noLeftPadding ? { paddingLeft: 0 } : undefined} className="flex-column gap main-section-template-fields-padding">
    <AddressWithNameInnerForm
      address={props.value.postalAddress}
      onChange={onChange}
      submit={props.submit}
      isSaving={props.isSaving}
      renderIsPostalAddressCheckbox={() => <div style={{ paddingTop: 4, paddingLeft: 8 }}>
        <Checkbox
          label={RESX.Company.SameAsVisitingAddress}
          checked={isSameAsVisitingAddress}
          onChange={(_, checked) => onCheck(checked)}
        />
      </div>}
    />
  </div>
}